import React from 'react';
import { IntercomProvider as IntercomProviderDefault } from 'react-use-intercom';
import { INTERCOM_APP_ID } from 'src/constants';
import app from 'srcJs/App';
import { useUserData } from 'components/user/hooks/use-user-data';

var IntercomProvider = function IntercomProvider(_ref) {
  var children = _ref.children;

  if (!app.getExternalApp().isEnableIntercom()) {
    return children;
  }

  var userData = useUserData();
  return /*#__PURE__*/React.createElement(IntercomProviderDefault, {
    appId: INTERCOM_APP_ID,
    autoBoot: true,
    autoBootProps: {
      userId: String(userData.id),
      name: userData.fullName,
      email: userData.email,
      createdAt: String(userData.createdAt)
    }
  }, children);
};

export { IntercomProvider };